import firebase from 'firebase/app'
import 'firebase/storage'

const state = {
    progress: 0,
}

const getters = {
    progress: (state) => state.progress,
}

const mutations = {
    UPDATE_PROGRESS: (state, progress) => (state.progress = Math.floor(progress)),
}

const actions = {
    upload: ({ commit }, { path = 'files', file }) => {
        commit('UPDATE_PROGRESS', 0)
        const storageRef = firebase.storage().ref(`${path}/${file.name}`).put(file)
        return new Promise((resolve, reject) => {
            storageRef.on(
                'state_changed',
                snapshot => commit('UPDATE_PROGRESS', (snapshot.bytesTransferred / snapshot.totalBytes) * 100),
                error => { reject(error) },
                () => {
                    commit('UPDATE_PROGRESS', 100)
                    setTimeout(() => commit('UPDATE_PROGRESS', 0), 300)
                    storageRef
                        .snapshot
                        .ref
                        .getDownloadURL()
                        .then(url => resolve(url))
                }
            )
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
